// Normalize names only; values and repeated parameter order stay intact.
export class CaseInsensitiveSearchParams extends URLSearchParams {
  constructor(init) {
    super();
    for (const [name, value] of new URLSearchParams(init)) {
      super.append(name.toLowerCase(), value);
    }
  }

  append(name, value) {
    super.append(String(name).toLowerCase(), value);
  }

  get(name) {
    return super.get(String(name).toLowerCase());
  }

  getAll(name) {
    return super.getAll(String(name).toLowerCase());
  }

  has(name, value) {
    return super.has(String(name).toLowerCase(), value);
  }

  set(name, value) {
    super.set(String(name).toLowerCase(), value);
  }

  delete(name, value) {
    super.delete(String(name).toLowerCase(), value);
  }
}
